// src/pages/dashboard/talent/TalentSidebar.js

import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

import {
  UserCircle,
  Briefcase,
  Settings,
  LogOut,
  Star,
  User,MessageSquare,Video,Image
} from 'lucide-react';

import { useAuth } from '../../../context/AuthContext';

import './TalentSidebar.css';

const TalentSidebar = () => {

  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // USER DATA
  const displayName = user?.full_name || 'Talent';
  const displayRole = user?.role || 'Actor / Model';
  const profileImageUrl = user?.profile_image_url || '';

  // FALLBACK AVATAR
  const defaultAvatar = `https://ui-avatars.com/api/?name=${encodeURIComponent(displayName)}&background=d90429&color=fff&size=150`;

  const imageSource = profileImageUrl ? profileImageUrl : defaultAvatar;

  return (
    <div className="talent-sidebar py-4">

      {/* PROFILE + MENU */}
      <div className="talent-main-card mt-5">

        {/* PROFILE */}
        <div className="sidebar-profile text-center mb-4">

          <img
            src={imageSource}
            alt="Talent Profile"
            className="td-profile-img"
            onError={(e) => {
              e.target.src = defaultAvatar;
            }}
          />

          <h4 className="text-white fw-bold m-0" style={{ fontSize: '18px' }}>
            {displayName}
          </h4>

          <p className="text-muted small m-0 text-capitalize">
            {displayRole}
          </p>

        </div>


        {/* SIDEBAR MENU */}

        <div className="talent-sidebar-nav">

          <NavLink
            to="/dashboard/overview"
            className={({ isActive }) =>
              isActive ? "menu-item active" : "menu-item"
            }
          >
            <User size={18} />
            Dashboard
          </NavLink>


          <NavLink
            to="/dashboard/profile"
            className={({ isActive }) =>
              isActive ? "menu-item active" : "menu-item"
            }
          >
            <UserCircle size={16} />
            Profile
          </NavLink>


          <NavLink
            to="/dashboard/my-audition"
            className={({ isActive }) =>
              isActive ? "menu-item active" : "menu-item"
            }
          >
            <Briefcase size={16} />
            My Applications
          </NavLink>
          <NavLink
            to="/dashboard/meetings"
            className={({ isActive }) =>
              isActive ? "menu-item active" : "menu-item"
            }
          >
            <Video size={16} />
            Meetings
          </NavLink>

          <NavLink
            to="/dashboard/platform-feedback"
            className={({ isActive }) =>
              isActive
              ? "menu-item active"
              : "menu-item"
            }
          >
            <MessageSquare size={16} />
            Platform Feedback
          </NavLink>

          <NavLink
            to="/dashboard/billing"
            className={({ isActive }) =>
                isActive
                    ? "menu-item active"
                    : "menu-item"
            }
        >
            <Briefcase size={16} />
            Billing
        </NavLink>
         <NavLink
            to="/dashboard/media-gallery"
            className={({ isActive }) =>
              isActive ? "menu-item active" : "menu-item"
            }
          >
            <Image size={16} />
            Media Gallery
          </NavLink>


          <NavLink
            to="/dashboard/ChangePasswordPage"
            className={({ isActive }) =>
              isActive ? "menu-item active" : "menu-item"
            }
          >
            <Settings size={16} />
            Settings
          </NavLink>

        </div>


        {/* LOGOUT */}

        <div
          className="logout mt-3 pt-3 border-top border-secondary d-flex align-items-center gap-2 text-danger"
          onClick={handleLogout}
          style={{ cursor: 'pointer' }}
        >
          <LogOut size={16} />
          <span className="fw-bold">Sign Out</span>
        </div>

      </div>


      {/* PRO FEATURES CARD */}

      {/* <div className="talent-pro-card mt-4">

        <div className="pro-title d-flex align-items-center gap-2 fw-bold text-warning mb-2">
          <Star size={16} fill="currentColor" />
          <span>Pro Features</span>
        </div>

        <p className="pro-text small text-white-50 mb-3">
          Unlock AI self-tape scoring and priority role matching.
        </p>

        <button className="pro-btn w-100 btn btn-warning fw-bold text-dark rounded-pill py-2">
          Upgrade Now
        </button>

      </div> */}

    </div>
  );
};

export default TalentSidebar;